import OrderFormStep from "../common/OrderFormStep";

export default class DesignerLinerProxy extends OrderFormStep {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (!this.props.isBack) {
      this.props.handleNext(this.props.currentIndex, this.props.orderIndex);
    } else {
      this.props.handleBack(this.props.currentIndex - 1, this.props.formIndex)
    }
  }

  render() {
    return (
      <></>
    );
  }
}
